import "./AppUse.css";
import logo from "../../../assets/images/brieffo.svg";
import { FaChevronCircleUp } from "react-icons/fa";
import { FaChevronCircleDown } from "react-icons/fa";
import { FaChevronCircleRight } from "react-icons/fa";

const AppUse = () => {
  return (
    <div className="appUse-section">
      <div className="appUse-left-section ">
        <h1>
          Përdorimi i<br />
          <span className="yellowText">Aplikacionit</span>
        </h1>

        <div className="steps-section">
          <div className="steps-description">
            <li className="slide-in-top">
              <FaChevronCircleDown />
            </li>
            <h1>Lëvizni poshtë</h1>
            <p>Lajmet e fundit</p>
          </div>
          <div className="steps-description">
            <li className="slide-in-top">
              <FaChevronCircleUp />
            </li>

            <h1>Lëvizni lartë</h1>
            <p>Lajmet e mëparshme</p>
          </div>
          <div className="steps-description">
            <li className="slide-in-top">
              <FaChevronCircleRight />
            </li>

            <h1>Klikoni mbi titull</h1>
            <p>Lajmi i plotë në platformë</p>
          </div>
        </div>
      </div>

      <div className="appUse-right-section">
        <img
          src={logo}
          alt=""
          className="slide-in-right"
          style={{ width: "9rem" }}
        />
      </div>
    </div>
  );
};

export default AppUse;
